import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getBanca } from '../services/api';
import { Container, Card, Button, Row, Col, Spinner, Alert } from 'react-bootstrap';

function BancheDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const tornaIndietro = useTornaIndietro('/banche');
  const [banca, setBanca] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanca = async () => {
      try {
        const response = await getBanca(id);
        setBanca(response.data);
        setLoading(false);
      } catch (err) {
        setError('Errore nel caricamento della banca.');
        setLoading(false);
      }
    };
    fetchBanca();
  }, [id]);

  if (loading) {
    return <Spinner animation="border" />;
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  if (!banca) {
    return <Alert variant="warning">Banca non trovata.</Alert>;
  }

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col>
          <h2 className="mb-0">Dettaglio Banca: {banca.denominazione}</h2>
        </Col>
        <Col xs="auto" className="ms-auto">
          <Button variant="secondary" onClick={tornaIndietro} className="me-2">
            Torna alla Lista
          </Button>
          <Button variant="warning" onClick={() => navigate(`/banche/edit/${id}`)} className="me-2">
            Modifica
          </Button>
          <Button variant="info" onClick={() => window.print()} disabled={loading}>
            Stampa
          </Button>
        </Col>
      </Row>

      <Card className="mb-4">
        <Card.Header as="h5">Dati Banca</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <p><strong>ID:</strong> {banca.id}</p>
              <p><strong>Denominazione:</strong> {banca.denominazione}</p>
              <p><strong>Referente:</strong> {banca.referente || 'N/A'}</p>
            </Col>
            <Col md={6}>
              <p><strong>Telefono:</strong> {banca.telefono || 'N/A'}</p>
              <p><strong>Cellulare:</strong> {banca.cellulare || 'N/A'}</p>
              <p><strong>Email:</strong> {banca.email || 'N/A'}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Header as="h5">Dati Bancari</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <p><strong>IBAN:</strong> {banca.iban || 'N/A'}</p>
              <p><strong>BIC/Swift:</strong> {banca.bic || 'N/A'}</p>
            </Col>
            <Col md={6}>
              <p><strong>Costo Transazione (%):</strong> {banca.costo_transazione_percentuale != null ? banca.costo_transazione_percentuale : 'N/A'}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default BancheDetail;